module.exports = __webpack_public_path__ + "img/hohlschnitt_ultramarinblau_ral5002.6c8095cc.jpg";